"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const useDidMount = (callback) => {
    React.useEffect(() => {
        callback();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
exports.default = useDidMount;
